import React from 'react';
import { View } from 'react-native';

import SwitchWithLabel from '../../../components/switch/SwitchWithLabel';
import Text from '../../../components/text/Text';
import { useThemedStyles } from '../../../hooks/useThemedStyles';

const SetupSwitchField = ({ label, value, onChange, hint, required = false, disabled = false }) => {
	const styles = useThemedStyles(createStyles);

	return (
		<View style={styles.container}>
			<SwitchWithLabel
				label={label}
				required={required}
				value={Boolean(value)}
				onValueChange={onChange}
				disabled={disabled}
			/>
			{
				hint && (
					<Text style={styles.hint}>{hint}</Text>
				)
			}
		</View>
	);
};

const createStyles = ({ ui: { colors, type, space } }) => ({
	container: {
		paddingVertical: space.xs,
	},
	hint: {
		...type.secondary,
		color: colors.textSecondary,
		marginLeft: space.xxs,
		marginTop: space.xs,
	},
});

export default SetupSwitchField;
